import React, {useEffect, useRef, useState} from "react";
import {CircularProgress} from "@material-ui/core";
import axios from "axios";
import ManShruggingImage from "../../../resources/images/man-shrugging.png";
import RouteTimeCircle from "../../Components/RouteTimeCircle/RouteTimeCircle";
import {secondsBetween, secondsUntil} from "../../Utils/TimeUtils";
import LogoImage from "../../../resources/images/ShipitLogo.png";
import moment from "moment";
import useInterval from "../../Components/Utils/UseInterval";
import './style.scss';
import Direction from "../../Utils/Direction/Direction";


async function fetchOrderTracking(shortId, isLoad) {
    let refreshCount = -1;

    if (sessionStorage.getItem('refreshCount') != null)
        refreshCount = parseInt(sessionStorage.getItem('refreshCount'));

    if (isLoad) {
        refreshCount++;

        sessionStorage.setItem('refreshCount', refreshCount.toString());
    }

    const {data: trackerData} = await axios.get(`api/v2/tracker/?id=${shortId}&load=${isLoad}&refresh=${refreshCount}`);

    return trackerData;
}

function OrderTrackerLoader() {
    return (
        <div className="order-loader-wrapper">
            <div className="order-loader">
                <CircularProgress/>
            </div>
        </div>
    );
}

function OrderTrackerError({errorType}) {
    let errorContent = <div>שגיאה לא ידועה</div>;

    switch (errorType) {
        case "OrderShortIdNotFound":
            errorContent = (
                <div className="error-content">
                    <img className="error-image" src={ManShruggingImage} alt="Order not found"/>
                    <h2 className="error-description">
                        ההזמנה לא נמצאה
                    </h2>
                </div>
            )
            break;
    }

    return (
        <div className="tracker-error">
            {errorContent}
        </div>
    );
}

function CountDownRouteTimeCircle({status, totalDuration, durationTillFinish, stopDecreaseOn, children}) {
    const [currDurationTillFinish, setCurrDurationTillFinish] = useState(durationTillFinish);
    const [isIntervalEnabled, setIntervalEnabled] = useState(true);

    useEffect(() => {
        setCurrDurationTillFinish(durationTillFinish);
    }, [durationTillFinish]);

    useInterval(decreaseSecondDurationTillFinish, isIntervalEnabled ? 1000 : null);

    function decreaseSecondDurationTillFinish() {
        if (!currDurationTillFinish)
            return;

        const newCurrDurationTillFinish = currDurationTillFinish - 1;

        if (newCurrDurationTillFinish <= stopDecreaseOn)
            setIntervalEnabled(false);
        else
            setCurrDurationTillFinish(currDurationTillFinish - 1);
    }

    if (currDurationTillFinish === undefined || currDurationTillFinish < 0)
        return null;

    return (
        <RouteTimeCircle status={status}
                         totalDuration={totalDuration}
                         durationTillFinish={currDurationTillFinish}>
            {children}
        </RouteTimeCircle>
    );
}

function ScheduledRouteTimeCircle({orderTracking}) {
    const [orderTimeHumanized, setOrderTimeHumanized] = useState();

    useEffect(() => {
        setOrderTimeHumanized(moment(orderTracking.orderTime).format('HH:mm'));
    }, [orderTracking]);

    return (
        <RouteTimeCircle status={"SCHEDULED"} totalDuration={1} durationTillFinish={1}>
            <React.Fragment>
                <div className="pie-chart-text-description" style={{fontSize: "1.1em"}}>
                    הזמנים יופיעו בשעה
                </div>
                <div className="pie-chart-text-description">
                    {orderTimeHumanized}
                </div>
            </React.Fragment>
        </RouteTimeCircle>
    );
}

function PreparingRouteTimeCircle({orderTracking}) {
    const [totalSecondsSla, setTotalSecondsSla] = useState();
    const [durationTillFinish, setDurationTillFinish] = useState();
    const [minutesRangeText, setMinutesRangeText] = useState();

    useEffect(() => {
        updateStates();
    }, [orderTracking]);

    function updateStates() {
        const totalSecondsSlaTmp = orderTracking.sla * 60;
        const slaEta = new Date(new Date(orderTracking.orderTime).getTime() + totalSecondsSlaTmp * 1000)
        let secondsTillDeliverySla = secondsUntil(slaEta);

        if (secondsTillDeliverySla < 25 * 60)
            secondsTillDeliverySla = 25 * 60

        setTotalSecondsSla(totalSecondsSlaTmp);
        setDurationTillFinish(Math.max(secondsTillDeliverySla, 20));

        let minutesTillDelivery = Math.floor(secondsTillDeliverySla / 60);

        while (minutesTillDelivery % 5 !== 0)
            minutesTillDelivery--;

        setMinutesRangeText(`${minutesTillDelivery - 15}-${minutesTillDelivery + 5}`)
    }

    useInterval(() => updateStates(), 5000);

    return (
        <CountDownRouteTimeCircle status={"PREPARING"}
                                  totalDuration={totalSecondsSla}
                                  durationTillFinish={durationTillFinish}
                                  stopDecreaseOn={20}>
            <React.Fragment>
                <div className="pie-chart-text-value">
                    {minutesRangeText}
                </div>
                <div className="pie-chart-text-value-description">
                    דקות
                </div>
            </React.Fragment>
        </CountDownRouteTimeCircle>
    );
}

function DeliveringRouteTimeCircleContent({secondsTillDelivery, stopDecreaseOn}) {
    const [minutesRangeText, setMinutesRangeText] = useState();
    const [currSecondsTillDelivery, setCurrSecondsTillDelivery] = useState(secondsTillDelivery);
    const [isIntervalEnabled, setIntervalEnabled] = useState(true);
    const minusSeconds = 10;

    useInterval(decreaseSecondsTillDelivery, isIntervalEnabled ? minusSeconds * 1000 : null);

    useEffect(() => {
        setCurrSecondsTillDelivery(secondsTillDelivery);
    }, [secondsTillDelivery]);

    useEffect(() => {
        updateMinutesRangeText();
    }, [currSecondsTillDelivery]);

    function decreaseSecondsTillDelivery() {
        if (!currSecondsTillDelivery)
            return;

        const newCurrSecondsTillDelivery = currSecondsTillDelivery - minusSeconds;

        if (newCurrSecondsTillDelivery <= stopDecreaseOn)
            setIntervalEnabled(false);
        else
            setCurrSecondsTillDelivery(newCurrSecondsTillDelivery);
    }

    function updateMinutesRangeText() {
        let minutesTillDelivery = Math.floor(currSecondsTillDelivery / 60);

        while (minutesTillDelivery % 5 !== 0)
            minutesTillDelivery--;

        if (minutesTillDelivery < 5)
            setMinutesRangeText(`${Math.max(minutesTillDelivery, 0) + 5}`);
        else
            setMinutesRangeText(`${minutesTillDelivery}-${minutesTillDelivery + 10}`);
    }

    if (currSecondsTillDelivery === undefined || currSecondsTillDelivery < 0)
        return null;

    return (
        <React.Fragment>
            <div className="pie-chart-text-value">
                {minutesRangeText}
            </div>
            <div className="pie-chart-text-value-description">
                דקות
            </div>
        </React.Fragment>
    );
}

function DeliveringRouteTimeCircle({orderTracking}) {
    const [totalSeconds, setTotalSeconds] = useState();
    const [secondsTillDelivery, setSecondsTillDelivery] = useState();
    const [secondsTillDeliveryMax, setSecondsTillDeliveryMax] = useState();

    useEffect(() => {
        const secondsTillDeliveryTmp = secondsUntil(orderTracking.eta);

        setSecondsTillDelivery(secondsTillDeliveryTmp);
        setSecondsTillDeliveryMax(Math.max(secondsTillDeliveryTmp, 20));

        setTotalSeconds(secondsBetween(orderTracking.eta, orderTracking.orderTime));
    }, [orderTracking]);

    return (
        <CountDownRouteTimeCircle status={"ACCEPTED"}
                                  totalDuration={totalSeconds}
                                  durationTillFinish={secondsTillDeliveryMax}
                                  stopDecreaseOn={20}>
            <DeliveringRouteTimeCircleContent secondsTillDelivery={secondsTillDelivery} stopDecreaseOn={20}/>
        </CountDownRouteTimeCircle>
    );
}

function DeliveredRouteTimeCircle() {
    return (
        <RouteTimeCircle status={"DELIVERED"} totalDuration={1} durationTillFinish={0}>
            <React.Fragment>
                <div className="pie-chart-text-description">
                    ההזמנה
                </div>
                <div className="pie-chart-text-description">
                    נמסרה
                </div>
            </React.Fragment>
        </RouteTimeCircle>
    );
}

function OrderRouteTimeCircleLoader({width}) {
    return (
        <React.Fragment>
            <div className="circular-progress-wrapper">
                <div className="circular-progress-inner-wrapper-1">
                    <CircularProgress
                        size={width * 0.86}
                        thickness={1}/>
                </div>
            </div>
            <div className="circular-progress-wrapper">
                <div className="circular-progress-inner-wrapper-2">
                    <CircularProgress
                        size={width * 0.81}
                        thickness={0.5}/>
                </div>
            </div>
            <div className="circular-progress-wrapper">
                <div className="circular-progress-inner-wrapper-3">
                    <CircularProgress
                        size={width * 0.78}
                        thickness={0.2}/>
                </div>
            </div>
        </React.Fragment>
    );
}

function OrderRouteTimeCircle({orderTracking}) {
    const [showLoader, setShowLoader] = useState(false);
    const [routeTimeCircle, setRouteTimeCircle] = useState();
    const routeTimeCircleWrapperRef = useRef();

    useEffect(() => {
        switch (orderTracking.status) {
            case "SCHEDULED":
                setShowLoader(true);
                setRouteTimeCircle(<ScheduledRouteTimeCircle orderTracking={orderTracking}/>);
                break;
            case "PREPARING":
                setShowLoader(true);
                setRouteTimeCircle(<PreparingRouteTimeCircle orderTracking={orderTracking}/>);
                break;
            case "DELIVERING":
                setShowLoader(true);
                setRouteTimeCircle(<DeliveringRouteTimeCircle orderTracking={orderTracking}/>);
                break;
            case "DELIVERED":
                setShowLoader(false);
                setRouteTimeCircle(<DeliveredRouteTimeCircle/>);
                break;
        }
    }, [orderTracking]);

    return (
        <div className="order-tracking-content">
            <div className="route-time-circle-wrapper" ref={routeTimeCircleWrapperRef}
                 style={routeTimeCircleWrapperRef.current ?
                     {fontSize: routeTimeCircleWrapperRef.current.clientWidth / 12}
                     :
                     {}}>
                {
                    routeTimeCircleWrapperRef.current ?
                        <React.Fragment>
                            {routeTimeCircle}
                            {
                                showLoader ?
                                    <OrderRouteTimeCircleLoader width={routeTimeCircleWrapperRef.current.clientWidth}/>
                                    :
                                    null
                            }
                        </React.Fragment>
                        :
                        null
                }
            </div>
        </div>
    );
}

export default function OrderTracker(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [orderTracking, setOrderTracking] = useState();
    const [isUpdateOrderTracking, setIsUpdateOrderTracking] = useState(true);

    async function updateOrderTracking(isLoad) {
        const shortId = props.match.params.id;

        const newOrderTracking = await fetchOrderTracking(shortId, isLoad);

        if (!_.isEqual(orderTracking, newOrderTracking)) {
            setOrderTracking(newOrderTracking);

            if (isLoading)
                setIsLoading(false);

            // Stopping the update order tracking interval if the order has been delivered
            if ("error" in newOrderTracking || newOrderTracking.status === "DELIVERED")
                setIsUpdateOrderTracking(false);
        }
    }

    useEffect(() => {
        updateOrderTracking(true);
    }, []);

    useInterval(() => updateOrderTracking(false), isUpdateOrderTracking ? 30 * 1000 : null);

    return (
        <Direction direction="rtl">
            <div className="order-tracker">
                <div className="logo">
                    <img src={LogoImage} alt="Shipit"/>
                </div>
                {
                    isLoading ?
                        <OrderTrackerLoader/>
                        :
                        (
                            "error" in orderTracking ?
                                <OrderTrackerError errorType={orderTracking.error}/>
                                :
                                <OrderRouteTimeCircle orderTracking={orderTracking}/>
                        )

                }
            </div>
        </Direction>
    );
}